import { ImResponse, resolve, storeHomeNVClient } from 'services/api';

export function authERP(body: Omit<ERP.QIANYI, 'id'>) {
  return storeHomeNVClient.post<ImResponse<string>>('/erp/auth', body);
}

export function getERPList() {
  return resolve(storeHomeNVClient.get<ImResponse<ERP.ERP[]>>('/erp/list'));
}

export function unAuthERP(id: number | string) {
  return storeHomeNVClient.post('/erp/unAuth', { id });
}

export function generalAuthUrl(
  body: Pick<
    ERP.JUSHUITAN,
    'erpType' | 'openLogisticsApi' | 'itemQueryType' | 'reissueItemQueryType' | 'storeIds'
  > & {
    id?: string;
  },
) {
  return resolve(storeHomeNVClient.post<ImResponse<string>>('/erp/general_auth_url', body));
}

export function updateERP(
  body: Pick<
    ERP.JUSHUITAN,
    'id' | 'openLogisticsApi' | 'itemQueryType' | 'reissueItemQueryType' | 'storeIds'
  >,
) {
  return storeHomeNVClient.post('/erp/update', body);
}

export function getWmList() {
  return resolve(storeHomeNVClient.get<ImResponse<ERP.ERPWm[]>>('/erp/list_wms'));
}

export function updateWmCountry(body: { wmsList: Pick<ERP.Wm, 'id' | 'countryList'>[] }) {
  return storeHomeNVClient.post('/erp/update_wms', body);
}

export function updateWmStoreIds(body: Pick<ERP.Wm, 'id' | 'storeIds' | 'reissueStoreIds'>) {
  return storeHomeNVClient.post('/erp/wms/update', body);
}
